module.exports = __webpack_public_path__ + "img/food.e451b578.png";